/* eslint-disable import/prefer-default-export */
import createAction from '@clearscore/helpers.create-action';
import createRequestPayload from '@clearscore/helpers.create-request-payload';

import { DASHBOARD_FETCH } from './dashboard.types';

// DASHBOARD_FETCH
export const fetch = () =>
    createAction(DASHBOARD_FETCH, createRequestPayload('international', '/report-viewer/v2/dashboard'));
